'use client';

import { ErrorBoundary } from '@benzinga/core-ui';
import { NavigationFooter } from '@benzinga/navigation-ui';
import React from 'react';
import { PageProps } from '../../../src/components/Page';

interface RootFooterProps {
  pageProps?: PageProps;
}
const RootFooter = ({ pageProps }: RootFooterProps) => {
  return (
    <>
      {!pageProps?.headerProps?.hideFooter && (
        <ErrorBoundary name="footer">
          <NavigationFooter
            copyrightLinks={pageProps?.headerProps?.copyrightLinks}
            logoVariant={pageProps?.headerProps?.logoVariant}
            menu={pageProps?.headerProps?.footerMenu}
            showStickyFooter={pageProps?.headerProps?.showStickyFooter}
            variant={pageProps?.headerProps?.footerVariant}
          />
        </ErrorBoundary>
      )}
    </>
  );
};

export default RootFooter;
